export class CreditosConEmpleadosModel {

  uid: string;
  employeesId: number;
  employeesName: string;
  filesCreditosConEmpleadosUid: string;
  importeInicial: number;
  importePendiente: number;
  fechaConstitucion: Date;
  plazo: number;
  fechaFinalizacion: Date;
  tipoInteres: number;
  carencia: number;
  tipoLiquidaciones: number;
  bankAccountsUid: string;

  constructor() { }

  // Enums - No eliminar
  /* Mensual = 1,
  Bimensual = 2,
  Trimestral = 3,
  Semestral = 4,
  Anual = 5 */

}

export class ConstitucionDelCreditoCreditosConEmpleadosModel {

  uid: string;
  creditosConEmpleadosId: string;
  plazo: number;
  fecha: Date;
  concepto: string;
  importe: number;
  comisionApertura: number;
  gastosBancarios: number;
  bankAccountsUid: string;
  bankAccountInfo: string;

  activitiesUid: string;
  activitiesName: string;

  constructor() {
    this.plazo = 0;
    this.comisionApertura = 0;
    this.gastosBancarios = 0;
  }

  // Enums - No eliminar
  /* Corto_Plazo = 1,
  Largo_Plazo = 2, */

}

export class DeudaACortoPlazoCreditosConEmpleadosModel {

  uid: string;
  creditosConEmpleadosId: string;
  fecha: Date;
  concepto: string;
  importe: number;

  activitiesUid: string;
  activitiesName: string;

  constructor() { }

}

export class CobroCuotasCreditosConEmpleadosModel {

  uid: string;
  creditosConEmpleadosId: string;
  fecha: Date;
  concepto: string;
  importeCapital: number;
  intereses: number;
  bankAccountsUid: string;
  bankAccountInfo: string;

  activitiesUid: string;
  activitiesName: string;

  constructor() {
    this.intereses = 0;
  }

}

